import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import HighchartsExporting from 'highcharts-exporting';
import { isExportingSelector } from 'selectors/indicator';
import mapSelectors from 'selectors/indicator/maps';
import disableMapControls from 'services/disableMapControls';

// Attaching exporting jazz to highmaps
HighchartsExporting(ReactHighmaps.Highcharts);

class HighmapsWrapper extends Component {
  componentDidUpdate() {
    const { config } = this.props;
    this.chart.update({ ...config }, true, true);
  }

  render() {
    const { config } = this.props;
    return (
      <ReactHighmaps
        config={config}
        callback={(chart) => { this.chart = chart; }}
      />
    );
  }
}

HighmapsWrapper.defaultProps = {
  group: '',
  timeframe: '',
};

HighmapsWrapper.propTypes = {
  config: PropTypes.object.isRequired, // Build out this prop type
  // These are used in mapStateToProps
  group: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  timeframe: PropTypes.oneOfType([ // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
  type: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
};

const mapStateToProps = (state, ownProps) => ({
  config: {
    ...mapSelectors[ownProps.type](state, ownProps),
    ...disableMapControls(isExportingSelector(state)),
  },
});

export default connect(mapStateToProps)(HighmapsWrapper);



// WEBPACK FOOTER //
// ./app/components/highmapsWrapper/index.js